<template>
  <div v-if="hasCombo" class="combo-line">
    <span class="tag is-success is-light">
      {{
        $t("transactions.comboPayTake", {
          buyQty: item.combo.buyQty,
          takeQty: item.combo.takeQty
        })
      }}
    </span>
    <span class="combo-full-price">
      {{ `${payments.currencySymbol}${formatMoney(fullPrice)}` }}
    </span>
    <span>&rarr;</span>
    <b>{{ `${payments.currencySymbol}${formatMoney(total)}` }}</b>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../../mixins/mask";

// "pague X leve Y": o total do item no carrinho é a soma do rateio (segments)
export default {
  props: ["item"],

  mixins: [mask],

  computed: {
    ...mapGetters(["payments"]),

    hasCombo() {
      return !!(
        this.item.combo &&
        this.item.combo.segments &&
        this.item.combo.segments.length > 0
      );
    },

    total() {
      return this.item.combo.segments.reduce(
        (sum, s) => sum + s.qty * s.unitPrice,
        0
      );
    },

    fullPrice() {
      const price = this.item.priceFrom ? this.item.priceFrom : this.item.price;
      return price * this.item.quantity;
    }
  }
};
</script>

<style scoped>
.combo-line {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.125rem;
  font-size: 0.85em;
  white-space: nowrap;
}
.combo-full-price {
  text-decoration: line-through;
  color: #919292;
}
</style>
